/**
 * kult-home-bestseller.js — Zubereitungs-Tabs der Startseiten-Section „Bestseller“ als Custom Element <kult-home-bestseller>.
 * DOM-Vertrag (sections/kult-home-bestseller.liquid, snippets/kult-home-bestseller-group.liquid):
 *   a[data-bestseller-tab][data-method="<key>"|""][data-label] → wird hier zu button[type=button][aria-pressed] (ohne JS bleiben Links)
 *   [data-bestseller-group="<key>"|""] genau eine sichtbar; [data-bestseller-status] (aria-live, data-template mit {label})
 *   ul[data-bestseller-track] Snap-Reihe mobil; [data-bestseller-dots] > span Positionsanzeige; data-active an Tab und Punkt
 *   data-ready am Element nach der Initialisierung (CSS blendet erst dann die Positionsanzeige ein).
 * State: localStorage 'kult:method' (Key, entfernt für „Alle“), html[data-kult-prep], Event 'kult:method:changed' {detail:{method}}
 * auf document (wird gesendet und empfangen; andere Startseiten-Sections dürfen ihn ebenfalls senden).
 * Editor: connectedCallback/disconnectedCallback decken shopify:section:load/unload ab, shopify:block:select zeigt die Gruppe
 * des angewählten Blocks. Run-once über customElements.get.
 */
(function () {
  'use strict';
  if (!window.customElements || window.customElements.get('kult-home-bestseller')) return;

  var KEY = 'kult:method';
  var VALID = /^[a-z-]{2,24}$/;

  function storedMethod() {
    var m = document.documentElement.getAttribute('data-kult-prep');
    if (!m) {
      try { m = window.localStorage.getItem(KEY); } catch (e) { m = null; }
    }
    return m && VALID.test(m) ? m : '';
  }

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function setActive(el, on) {
    if (on) el.setAttribute('data-active', ''); else el.removeAttribute('data-active');
  }

  class KultHomeBestseller extends HTMLElement {
    connectedCallback() {
      if (!this._onChange) {
        this._onChange = this.onChange.bind(this);
        this._onClick = this.onClick.bind(this);
        this._onScroll = this.onScroll.bind(this);
        this._onBlockSelect = this.onBlockSelect.bind(this);
      }
      document.addEventListener('kult:method:changed', this._onChange);
      document.addEventListener('shopify:block:select', this._onBlockSelect);
      this.addEventListener('click', this._onClick);
      this.upgradeTabs();
      var tracks = this.querySelectorAll('[data-bestseller-track]');
      for (var i = 0; i < tracks.length; i++) tracks[i].addEventListener('scroll', this._onScroll, { passive: true });
      this.apply(storedMethod(), false, null);
      this.setAttribute('data-ready', '');
    }

    disconnectedCallback() {
      document.removeEventListener('kult:method:changed', this._onChange);
      document.removeEventListener('shopify:block:select', this._onBlockSelect);
      this.removeEventListener('click', this._onClick);
      var tracks = this.querySelectorAll('[data-bestseller-track]');
      for (var i = 0; i < tracks.length; i++) tracks[i].removeEventListener('scroll', this._onScroll);
    }

    /* Links → Toggle-Buttons (alle Attribute außer href bleiben, inkl. data-* und Editor-Attribute). */
    upgradeTabs() {
      var links = this.querySelectorAll('a[data-bestseller-tab]');
      for (var i = 0; i < links.length; i++) {
        var a = links[i], b = document.createElement('button');
        b.type = 'button';
        for (var j = 0; j < a.attributes.length; j++) {
          if (a.attributes[j].name !== 'href') b.setAttribute(a.attributes[j].name, a.attributes[j].value);
        }
        b.innerHTML = a.innerHTML;
        a.parentNode.replaceChild(b, a);
      }
    }

    onClick(e) {
      var tab = e.target.closest ? e.target.closest('button[data-bestseller-tab]') : null;
      if (!tab || !this.contains(tab)) return;
      var method = tab.getAttribute('data-method') || '';
      if (method && !VALID.test(method)) return;
      if (tab.hasAttribute('data-active')) { this.reveal(tab, true); return; }
      try {
        if (method) window.localStorage.setItem(KEY, method); else window.localStorage.removeItem(KEY);
      } catch (err) { /* Speicher gesperrt: Auswahl gilt nur für diese Seite */ }
      if (method) document.documentElement.setAttribute('data-kult-prep', method);
      else document.documentElement.removeAttribute('data-kult-prep');
      this._clicked = tab;
      document.dispatchEvent(new CustomEvent('kult:method:changed', { detail: { method: method } }));
      this._clicked = null;
    }

    /* Theme-Editor: Block „methode“ angewählt → dessen Gruppe zeigen, ohne die Auswahl zu speichern. */
    onBlockSelect(e) {
      var t = e.target;
      if (!t || !this.contains(t) || !t.hasAttribute || !t.hasAttribute('data-bestseller-tab')) return;
      this.apply(t.getAttribute('data-method') || '', false, null);
    }

    onChange(e) {
      var m = e && e.detail && typeof e.detail.method === 'string' ? e.detail.method : storedMethod();
      this.apply(VALID.test(m) ? m : '', true, this._clicked);
    }

    /* Zeigt die Gruppe zu method (sonst „Alle“), setzt Tab-Zustand, kündigt an und holt den Tab in der Reihe ins Bild. */
    apply(method, announce, clicked) {
      var groups = this.querySelectorAll('[data-bestseller-group]'), on = null, fallback = null, i;
      for (i = 0; i < groups.length; i++) {
        var key = groups[i].getAttribute('data-bestseller-group');
        if (key === '') fallback = groups[i];
        if (method && key === method) on = groups[i];
      }
      if (!on) { on = fallback; method = ''; }
      if (!on) return;
      for (i = 0; i < groups.length; i++) groups[i].hidden = groups[i] !== on;

      var tabs = this.querySelectorAll('[data-bestseller-tab]'), active = null;
      for (i = 0; i < tabs.length; i++) {
        var hit = (tabs[i].getAttribute('data-method') || '') === method;
        setActive(tabs[i], hit);
        if (tabs[i].tagName === 'BUTTON') tabs[i].setAttribute('aria-pressed', hit ? 'true' : 'false');
        if (hit) active = tabs[i];
      }

      var status = this.querySelector('[data-bestseller-status]');
      if (status && announce && active) {
        status.textContent = (status.getAttribute('data-template') || '').replace('{label}', active.getAttribute('data-label') || '');
      }
      if (active) this.reveal(active, active === clicked);
      var track = on.querySelector('[data-bestseller-track]');
      if (track) { track.scrollLeft = 0; this.updateDots(track); }
    }

    /* Nur wenn die Tab-Reihe scrollt (mobil): nach Klick scrollIntoView, sonst ohne vertikalen Seitensprung zentrieren. */
    reveal(tab, fromClick) {
      var row = tab.parentNode;
      if (!row || row.scrollWidth <= row.clientWidth + 1) return;
      if (fromClick && tab.scrollIntoView) {
        tab.scrollIntoView({ inline: 'center', block: 'nearest', behavior: reducedMotion() ? 'auto' : 'smooth' });
      } else {
        row.scrollLeft = tab.offsetLeft - (row.clientWidth - tab.offsetWidth) / 2;
      }
    }

    onScroll(e) {
      var track = e.currentTarget, self = this;
      if (track._kultTick) return;
      track._kultTick = true;
      window.requestAnimationFrame(function () { track._kultTick = false; self.updateDots(track); });
    }

    updateDots(track) {
      var group = track.parentNode, dots = group ? group.querySelector('[data-bestseller-dots]') : null;
      if (!dots) return;
      var items = track.children, best = 0, min = Infinity, i;
      if (!items.length) return;
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2 && track.scrollLeft > 0) {
        best = items.length - 1;
      } else {
        for (i = 0; i < items.length; i++) {
          var d = Math.abs(items[i].offsetLeft - items[0].offsetLeft - track.scrollLeft);
          if (d < min) { min = d; best = i; }
        }
      }
      for (i = 0; i < dots.children.length; i++) setActive(dots.children[i], i === best);
    }
  }

  window.customElements.define('kult-home-bestseller', KultHomeBestseller);
})();
